<template>
    <div class="bg-indigo-50 p-4 rounded-lg" v-if="summary.length">
        <div v-for="category in summary" :key="category.id">
            <div class="">
                {{ category.name }}
            </div>
            <ul>
                <li class="pl-4 py-4 text-sm leading-5 text-gray-500">
                    <div v-for="dimension in category.filteredDimensions" :key="dimension.id">
                        {{ dimension.abbreviation }} - {{ dimension.title }}
                        <button
                            type="button"
                            @click="$emit('remove-dimension', dimension.id)"
                            class="text-red-300 hover:text-red-500 hover:font-bold"
                            :title="$t('messages.delete')"
                        >
                            x
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CategoryDimensionsSelectorSummary',
    emits: ['remove-dimension'],
    components: {},
    props: {
        categories: {
            required: true,
            type: Array,
        },
        modelValue: {
            required: true,
            type: Array,
        },
    },
    computed: {
        summary: function () {
            return JSON.parse(JSON.stringify(this.categories))
                .map((c) => {
                    c.filteredDimensions = c.dimensions.filter((d) => this.modelValue.includes(d.id));
                    return c;
                })
                .filter((c) => c.filteredDimensions.length > 0);
        },
    },
    data() {
        return {
            selected_category: null,
            dimension_ids: this.modelValue,
        };
    },
};
</script>
